export default __webpack_public_path__ + "static/media/gm-sg-girl.00656f3e.webp";